var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductoras(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 185.301,
    height: 203.79,
    viewBox: "0 0 185.301 203.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_588",
    "data-name": "Grupo 588",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_587",
    "data-name": "Grupo 587",
    transform: "translate(0 17.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_937",
    "data-name": "Trazado 937",
    d: "M3.665,44.668a7.275,7.275,0,0,0,6.742-4.352,7.393,7.393,0,0,0,.135-5.637c.206-.085.41-.174.621-.25-.31-.125-.611-.267-.911-.409A7.353,7.353,0,0,0,4.8,30.049,17.791,17.791,0,0,1,0,17.941,17.97,17.97,0,0,1,17.431,0l.227,0A12.025,12.025,0,0,1,28.082,6.09a7.342,7.342,0,0,0,6.339,3.631A7.317,7.317,0,0,0,39.692,7.49,19.478,19.478,0,0,1,50.359,1.576,39.163,39.163,0,0,1,58.73,1.1c19.612.975,36.486,18.357,36.9,37.989A38.881,38.881,0,0,1,28.141,66.261a16.352,16.352,0,0,0-12.233-5.3h-.142A13.664,13.664,0,0,1,2.1,47.3c0-.418.021-.832.06-1.24a1.546,1.546,0,0,1,1.5-1.388h0Z",
    transform: "translate(87.361 63.979) rotate(40)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_586",
    "data-name": "Grupo 586",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_938",
    "data-name": "Trazado 938",
    d: "M131.378,24.7.526,0,0,9.459,129.8,40.465Z",
    transform: "translate(33.648 29.882) rotate(40)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_939",
    "data-name": "Trazado 939",
    d: "M36.323,11.878,34.746,10.3s-6.832-3.153-6.832-3.679c0-.329-10.088-3.746-17.636-6.257A7.094,7.094,0,0,0,1.012,6.14L.066,13.076a7.1,7.1,0,0,0,6.746,8.048l18.475.739,8.934-2.1,2.1-7.883Z",
    transform: "translate(14.053 0) rotate(40)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_940",
    "data-name": "Trazado 940",
    d: "M130.853,26.342l.312-1.309L.228,0,0,1.642Z",
    transform: "translate(33.047 31.01) rotate(40)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_941",
    "data-name": "Trazado 941",
    d: "M130.553,26.237l.3-1.435L.086,0,0,1.679Z",
    transform: "translate(31.38 32.996) rotate(40)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_942",
    "data-name": "Trazado 942",
    d: "M130.27,27.329l.074-2.312L0,0,.017,1.369Z",
    transform: "translate(30.155 34.43) rotate(40)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_943",
    "data-name": "Trazado 943",
    d: "M130.222,28.9l-.1-2.093L.112,0,0,.513Z",
    transform: "translate(28.711 35.682) rotate(40)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_944",
    "data-name": "Trazado 944",
    d: "M130.03,30.134l-.1-1.564L.116,0,0,.512Z",
    transform: "translate(28.301 36.466) rotate(40)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_945",
    "data-name": "Trazado 945",
    d: "M288.88,21.167l-39.7,10.785,5.776,25.761a11.83,11.83,0,1,0,3.461,3.615L253.837,40.9l34.25-10.768,3.132,15.214a11.827,11.827,0,1,0,3.364,3.516l-5.7-27.7Z",
    transform: "translate(-161.862 -21.167)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_946",
    "data-name": "Trazado 946",
    d: "M330.575,46.084a11.6,11.6,0,0,0-10.45,16.673l6.632,27.355,3.764-.912L325.4,68.1a11.615,11.615,0,1,0,5.17-22.013Z",
    transform: "translate(-196.071 11.081)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_947",
    "data-name": "Trazado 947",
    d: "M379.106,107.553l-6.583-26.33-4,.939,5.149,20.595a12.59,12.59,0,0,0-5.207-1.129A11.967,11.967,0,1,0,380.8,113.589a11.613,11.613,0,0,0-1.7-6.036Z",
    transform: "translate(-195.504 -16.12)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductoras);
export default __webpack_public_path__ + "static/media/productoras.d0e6b8c1e27339a5979ca958f1c82d86.svg";
export { ForwardRef as ReactComponent };